// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.truncate {
  display: inline-block;
  max-width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pointer {
  cursor: pointer;
}

.token {
  background: #f4f4f4;
  position: relative;
  border: 3px solid #cccccc;
  padding: 10px;
  margin-bottom: 10px;
  width: 100%;
}
.token th, .token td {
  padding: 2px 10px;
}
.token th {
  text-align: right;
  border-right: 2px solid #cccccc;
}
.token td span {
  line-height: 30px;
}
.token .form-control {
  display: inline;
  height: auto;
  line-height: 1;
  margin-top: 5px;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImZpZG8uY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxxQkFBQTtFQUNBLGdCQUFBO0VBQ0EsbUJBQUE7RUFDQSxnQkFBQTtFQUNBLHVCQUFBO0FBQ0Y7O0FBRUE7RUFDRSxlQUFBO0FBQ0Y7O0FBRUE7RUFDRSxtQkFBQTtFQUNBLGtCQUFBO0VBQ0EseUJBQUE7RUFDQSxhQUFBO0VBQ0EsbUJBQUE7RUFDQSxXQUFBO0FBQ0Y7QUFDRTtFQUNFLGlCQUFBO0FBQ0o7QUFFRTtFQUNFLGlCQUFBO0VBQ0EsK0JBQUE7QUFBSjtBQUdFO0VBQ0UsaUJBQUE7QUFESjtBQUlFO0VBQ0UsZUFBQTtFQUNBLFlBQUE7RUFDQSxjQUFBO0VBQ0EsZUFBQTtBQUZKIiwiZmlsZSI6ImZpZG8uY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIudHJ1bmNhdGUge1xuICBkaXNwbGF5OiBpbmxpbmUtYmxvY2s7XG4gIG1heC13aWR0aDogMzAwcHg7XG4gIHdoaXRlLXNwYWNlOiBub3dyYXA7XG4gIG92ZXJmbG93OiBoaWRkZW47XG4gIHRleHQtb3ZlcmZsb3c6IGVsbGlwc2lzO1xufVxuXG4ucG9pbnRlciB7XG4gIGN1cnNvcjogcG9pbnRlcjtcbn1cblxuLnRva2VuIHtcbiAgYmFja2dyb3VuZDogI2Y0ZjRmNDtcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuICBib3JkZXI6IDNweCBzb2xpZCAjY2NjY2NjO1xuICBwYWRkaW5nOiAxMHB4O1xuICBtYXJnaW4tYm90dG9tOiAxMHB4O1xuICB3aWR0aDogMTAwJTtcblxuICB0aCwgdGQge1xuICAgIHBhZGRpbmc6IDJweCAxMHB4O1xuICB9XG5cbiAgdGgge1xuICAgIHRleHQtYWxpZ246IHJpZ2h0O1xuICAgIGJvcmRlci1yaWdodDogMnB4IHNvbGlkICNjY2NjY2M7XG4gIH1cblxuICB0ZCBzcGFuIHtcbiAgICBsaW5lLWhlaWdodDogMzBweDtcbiAgfVxuXG4gIC5mb3JtLWNvbnRyb2wge1xuICAgIGRpc3BsYXk6IGlubGluZTtcbiAgICBoZWlnaHQ6IGF1dG87XG4gICAgbGluZS1oZWlnaHQ6IDE7XG4gICAgbWFyZ2luLXRvcDogNXB4O1xuICB9XG59XG4iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/shared/enrollment/methods/fido/fido.component.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AACF;AACE;EACE,iBAAA;AACJ;AAEE;EACE,iBAAA;EACA,+BAAA;AAAJ;AAGE;EACE,iBAAA;AADJ;AAIE;EACE,eAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AAFJ;AACA,g3CAAg3C","sourcesContent":[".truncate {\n  display: inline-block;\n  max-width: 300px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.pointer {\n  cursor: pointer;\n}\n\n.token {\n  background: #f4f4f4;\n  position: relative;\n  border: 3px solid #cccccc;\n  padding: 10px;\n  margin-bottom: 10px;\n  width: 100%;\n\n  th, td {\n    padding: 2px 10px;\n  }\n\n  th {\n    text-align: right;\n    border-right: 2px solid #cccccc;\n  }\n\n  td span {\n    line-height: 30px;\n  }\n\n  .form-control {\n    display: inline;\n    height: auto;\n    line-height: 1;\n    margin-top: 5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
